import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { reduxConnect } from '../../common';
import { TermsAndPrivacyUpdate } from '../terms-and-privacy/termsAndPrivacyUpdate.jsx';
import { CookieNotification } from './cookieNotification.jsx';

const mapStoreStateToProps = storeState => {
    const appState = storeState.appState.appState || {};
    const {
        enableNotifications
        , enableUseOfCookiesNotification
        , enableTermsAndConditionsNotification
        , allowStorageOrCookieAccess
    } = appState;

    return {
        enableNotifications,
        enableUseOfCookiesNotification,
        enableTermsAndConditionsNotification,
        allowStorageOrCookieAccess
    };

};

const mapDispatchToProps = {};

const NotificationFooterComponent = ({
    allowStorageOrCookieAccess
    , enableNotifications=true
    , enableUseOfCookiesNotification=true
    , enableTermsAndConditionsNotification=true }) => {

    return (
        enableNotifications
        && <Container>
            {enableUseOfCookiesNotification && <CookieNotification allowCookieAccess={allowStorageOrCookieAccess} />}
            {enableTermsAndConditionsNotification && <TermsAndPrivacyUpdate />}
        </Container>
    );
};

export const NotificationFooter = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(NotificationFooterComponent);

NotificationFooterComponent.propTypes = {
    enableNotifications: PropTypes.bool,
    enableUseOfCookiesNotification: PropTypes.bool,
    enableTermsAndConditionsNotification: PropTypes.bool,
    allowStorageOrCookieAccess: PropTypes.bool
};

const Container = styled.div`
    width: 100%;
    z-index: 99;
`;
